import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from "mobx-react";
import * as React from "react";
import { FixedFooterNavigation, FixedFooterNavigationAction, GroupIcon, HomeIcon } from "./FixedFooterNavigationView.styles";
import { FixedFooterNavigationViewModel } from "./FixedFooterNavigationViewModel";
import { useViewModel } from "./useViewModel";
import { HXMobileTabBadge } from "./HXMobilePage.styles";
import { useTranslation } from "react-i18next";
export const FixedFooterNavigationView = observer((props) => {
    const { t } = useTranslation(["patients"]);
    const model = useViewModel(FixedFooterNavigationViewModel, {
        container: props.container,
    });
    return (_jsxs(FixedFooterNavigation, { showLabels: true, value: model.selectedBottomNavigationButton, onChange: (_, newValue) => {
            model.goToPage(newValue);
        }, children: [_jsx(FixedFooterNavigationAction, { label: t("Home"), icon: _jsx(HomeIcon, {}) }), _jsx(FixedFooterNavigationAction, { label: _jsxs(_Fragment, { children: [t("Sharing"), " ", model.showResearchBadge && _jsx(HXMobileTabBadge, {})] }), icon: _jsx(GroupIcon, {}) })] }));
});
